module.exports = __webpack_public_path__ + "static/logo_shadow-59b6db091ff6cc5ab81196ad6b886793.png";